import React, { useState, useRef, useEffect } from "react";
import "./Autocomplete.css";

function AutocompleteInput({
  name,
  placeholder,
  suggestions,
  label,
  value,
  updateValue,
  register,
  disabled,
}) {
  const [filtered, setFiltered] = useState([]);
  const [showList, setShowList] = useState(false);
  const wrapperRef = useRef(null);

  // Filter suggestions based on query
  useEffect(() => {
    if (value) {
      const q = value.toLowerCase();
      const matches = suggestions.filter((item) => {
        return item.name.toLowerCase().includes(q);
      });
      setFiltered(matches);
    } else {
      setFiltered(suggestions);
    }
  }, [value, suggestions]);

  // Hide dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="autocomplete-wrapper"
      ref={wrapperRef}
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
    >
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <input
        type="text"
        id={name}
        name={name}
        className="form-control form-control-sm"
        placeholder={placeholder}
        onFocus={() => setShowList(true)}
        {...register}
        style={{ fontSize: "1.05rem" }}
        readOnly={disabled}
        autoComplete="off"
      />
      {showList && filtered.length > 0 && (
        <ul className="autocomplete-list">
          {filtered.map((item) => (
            <li
              key={item.value}
              onClick={() => {
                updateValue(item.name);
                setShowList(false);
              }}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default React.memo(AutocompleteInput);
